import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useApi, errorApiRef } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import useAsyncRetry from 'react-use/esm/useAsyncRetry';

/**
 * Fetches a catalog entity based on URL route params (:kind, :namespace, :name).
 * Redirects to / if name is missing.
 */
export const useEntityFromUrl = () => {
  const { kind = '', namespace = 'default', name = '' } = useParams();
  const navigate = useNavigate();
  const errorApi = useApi(errorApiRef);
  const catalogApi = useApi(catalogApiRef);

  const {
    value: entity,
    error,
    loading,
    retry: refresh,
  } = useAsyncRetry(
    () => catalogApi.getEntityByRef({ kind, namespace, name }),
    [catalogApi, kind, namespace, name],
  );

  useEffect(() => {
    if (!name) {
      errorApi.post(new Error('No name provided!'));
      navigate('/');
    }
  }, [errorApi, navigate, name]);

  return { entity, loading, error, refresh, kind, namespace, name };
};
